import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-logger-type',
    templateUrl: './logger-type.component.html',
})
export class LoggerTypeComponent implements OnInit {
    @Input()
    logTypes: any;

    constructor() {}

    ngOnInit(): void {}

    getTypeClass(labelType) {
        switch (labelType) {
            case 'debug':
                return 'text-warning';
            case 'error':
                return 'text-danger';
            case 'info':
                return 'text-info';
            default:
                return 'text-dark';
        }
    }
}
